// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import axios from "axios";
// import { parse } from "tldts";
// import "../css/Preloader.css";

// const Preloader = ({ onComplete }) => {
//   const [percent, setPercent] = useState(0);
//   const [company, setCompany] = useState({ name: "Fintech", logo: null });

//   // Company Information Fetching (Same logic as Hero)
//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const hostname = window.location.hostname;
//         const { domain } = parse(hostname);
//         const response = await axios.get("https://payyug.in/api/get-company", {
//           params: { domain },
//         });
//         if (response.data) {
//           setCompany({
//             name: response.data.name || "Fintech Solutions",
//             logo: response.data.logo ? `https://payyug.in/${response.data.logo}` : null,
//           });
//         }
//       } catch (err) {
//         console.error("Loader brand fetch failed");
//       }
//     };
//     fetchCompany();
//   }, []);

//   // Smooth Percentage Increment
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setPercent((prev) => {
//         if (prev >= 100) {
//           clearInterval(interval);
//           setTimeout(onComplete, 800); 
//           return 100;
//         }
//         return prev + 1;
//       });
//     }, 35); 
//     return () => clearInterval(interval);
//   }, [onComplete]);

//   const defaultLogo = "https://cdn-icons-png.flaticon.com/512/2830/2830284.png";

//   return (
//     <motion.div
//       className="sv-loader-screen"
//       initial={{ opacity: 1 }}
//       exit={{ opacity: 0, scale: 1.05 }}
//       transition={{ duration: 0.8 }}
//     >
//       {/* Background Subtle Grid Effect */}
//       <div className="sv-loader-grid" />

//       <div className="sv-loader-content">
//         <div className="sv-logo-spinner-wrap">
//           {/* Animated Circles - mimicking the image pattern */}
//           {[...Array(3)].map((_, i) => (
//             <motion.div
//               key={i}
//               className="sv-loader-orbit"
//               animate={{ rotate: 360 }}
//               transition={{
//                 duration: 3 + i,
//                 repeat: Infinity,
//                 ease: "linear",
//               }}
//               style={{
//                 width: 140 + i * 40,
//                 height: 140 + i * 40,
//                 opacity: 0.3 - i * 0.1,
//               }}
//             />
//           ))}

//           {/* Central Brand Logo */}
//           <motion.div 
//             className="sv-loader-brand-circle"
//             initial={{ scale: 0 }}
//             animate={{ scale: 1 }}
//             transition={{ type: "spring", stiffness: 100 }}
//           >
//             <img 
//               src={company.logo || defaultLogo} 
//               alt="brand-logo" 
//               onError={(e) => (e.target.src = defaultLogo)}
//             />
//           </motion.div>
//         </div>

//         {/* Branding & Status */}
//         <div className="sv-loader-info">
//           <motion.h2 
//             initial={{ y: 20, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             className="sv-loader-brand-name"
//           >
//             {company.name}
//           </motion.h2>
          
//           <div className="sv-status-wrapper">
//              <span className="sv-percentage">{percent}%</span>
//              <p className="sv-status-text">
//                 {percent < 40 && "Initializing Secure Core..."}
//                 {percent >= 40 && percent < 80 && "Syncing Financial Data..."}
//                 {percent >= 80 && "Finalizing Encrypted Tunnel..."}
//              </p>
//           </div>

//           {/* Premium Progress Bar */}
//           <div className="sv-progress-track">
//             <motion.div 
//               className="sv-progress-fill"
//               style={{ width: `${percent}%` }}
//             />
//           </div>
//         </div>
//       </div>
//     </motion.div>
//   );
// };

// export default Preloader;






import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { parse } from "tldts";
import "../css/Preloader.css";

const Preloader = ({ onComplete }) => {
  const [percent, setPercent] = useState(0);
  const [company, setCompany] = useState({
    name: "Your Bank",
    logo: null,
    favicon: null,
    domain: "",
    subdomain: "",
    superAdminId: "",
  });

  const defaultLogo = "https://cdn-icons-png.flaticon.com/512/2830/2830284.png";

  // Helper to clean and format image URLs (Same as Navbar & Hero)
  const getImageUrl = (path) => {
    if (!path) return defaultLogo;
    const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
    return `https://payyug.in/${cleanPath}`;
  };

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://payyug.in/api/get-company", { params: { domain } });
        const data = response.data;

        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            favicon: data.favicon || prev.favicon,
            domain: data.domain || prev.domain,
            subdomain: data.subdomain || prev.subdomain,
            superAdminId: data.superAdminId || prev.superAdminId,
          }));

          // Favicon Update Logic with prefix cleaning
          if (data.favicon) {
            const cleanFav = data.favicon.startsWith("images/") ? data.favicon.slice(7) : data.favicon;
            const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = `https://payyug.in/${cleanFav}`;
            document.head.appendChild(link);
          }
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
      }
    };
    fetchCompany();
  }, []);

  useEffect(() => {
    let currentPercent = 0;
    let timeoutId;

    const updateProgress = () => {
      currentPercent += 1;
      setPercent(currentPercent);

      if (currentPercent < 100) {
        const nextTick = currentPercent > 80 ? 60 : 20;
        timeoutId = setTimeout(updateProgress, nextTick);
      } else {
        setTimeout(onComplete, 500);
      }
    };

    updateProgress();
    return () => clearTimeout(timeoutId);
  }, [onComplete]);

  const waveVariant = {
    animate: {
      d: [
        "M0,160L48,176C96,192,192,224,288,224C384,224,480,192,576,165.3C672,139,768,117,864,128C960,139,1056,181,1152,197.3C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
        "M0,192L48,213.3C96,235,192,277,288,266.7C384,256,480,192,576,160C672,128,768,128,864,149.3C960,171,1056,213,1152,202.7C1248,192,1344,128,1392,96L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
      ],
      transition: { duration: 4, repeat: Infinity, repeatType: "mirror", ease: "easeInOut" }
    }
  };

  return (
    <motion.div 
      className="landing-preloader-screen"
      exit={{ y: "-100%", opacity: 0 }} 
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="landing-wave-top">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
          <motion.path fill="rgba(26, 35, 126, 0.05)" variants={waveVariant} animate="animate" />
        </svg>
      </div>

      <div className="landing-loader-main-container">
        <div className="landing-loader-animation-box">
          <motion.div
            className="landing-loader-spiro-wrapper"
            animate={{ rotate: 360 }}
            transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
          >
            {[...Array(20)].map((_, i) => (
              <div
                key={i}
                className="landing-loader-flower-petal"
                style={{ 
                  transform: `rotate(${i * 18}deg) translateX(40px)`,
                  opacity: percent > i * 5 ? 0.6 : 0 
                }}
              />
            ))}
          </motion.div>

          <div className="landing-loader-center-logo">
            <div className="landing-loader-logo-inner">
              <img
                src={getImageUrl(company.logo)} // Using updated logic
                alt={company.name}
                onError={(e) => { e.target.src = defaultLogo; }}
              />
            </div>
          </div>
        </div>

        <div className="landing-loader-branding-box">
          <h2 className="landing-loader-company-name">{company.name}</h2>
          <div className="landing-loader-progress-section">
            <div className="landing-loader-bar-bg">
              <motion.div 
                className="landing-loader-bar-fill"
                style={{ width: `${percent}%` }}
              />
            </div>
            <div className="landing-loader-stats">
              <span className="landing-loader-percent-num">{percent}%</span>
              <span className="landing-loader-status-tag">{percent < 100 ? "Syncing..." : "Ready"}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="landing-wave-bottom">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
          <motion.path fill="rgba(46, 125, 50, 0.05)" variants={waveVariant} animate="animate" />
        </svg>
      </div>
    </motion.div>
  );
};

export default Preloader;